import client from '@/plugins/axios.js'


export default  {
    openOrder(){
        return new Promise((resolve,reject)=>{
          client({requiresAuth:true}).get('/api/order/openOrder' )
            .then((res)=>{
              resolve(res.data.data.primaryObject)
            })
            .catch((err)=>{
              console.log("Service:parties:openOrder - Error:",err)
              reject(err)
            })
        });      
    },

  dealersCustlist(){
        return new Promise((resolve,reject)=>{
          client({requiresAuth:true}).get('/api/order/dealersCustlist' )
            .then((res)=>{
              resolve(res.data.data.primaryObject)
            })
            .catch((err)=>{
              console.log("Service:parties:DealersCustlist - Error:",err)
              reject(err)
            })
        });      
    },

    orderHistory(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/order/orders/4' )
            .then((res)=>{
              resolve(res.data.data.primaryObject)
            })
            .catch((err)=>{
              console.log("Service:parties - Error:",err)
              reject(err)
            })
        });

    },
    invoiceHistory(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/dealer/invoices' )
            .then((res)=>{
              resolve(res.data.data)
              //resolve(res.data.data)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });

    },
    dealerInvoices(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/dealer/invoices/'+payload.dealerId )
                .then((res)=>{
                    resolve(res.data.data)
                    //resolve(res.data.data)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });

    },
    loadOrderById(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/order/byid/'+payload.orderId )
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });

    },
    handInOrder(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true, errAsObj:true}).post('/api/order/handin', payload )
            .then((res)=>{
              resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });

    },


    addParty(payload){
        return new Promise((resolve, reject)=>{
            client({requiresAuth: true}).post('/api/order/party/add', payload)
            .then(res => {
              resolve(res.data.data.primaryObject)
                })
                .catch(err => {
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    submitParty(payload){
        return new Promise((resolve, reject)=>{
            client({requiresAuth: true}).post(`/api/order/party/${payload.id}/submit`, payload)
                .then(res => {
                    resolve(res.data.data.primaryObject)
                })
                .catch(err => {
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    deleteParty(payload){
        return new Promise((resolve, reject)=>{
            client({requiresAuth: true}).post(`/api/order/party/${payload.id}/delete`, payload)
                .then(res => {
                    resolve(res.data.data.primaryObject)
                })
                .catch(err => {
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    resendDiscountEmail(payload){
        return new Promise((resolve, reject)=>{
            client({requiresAuth: true}).post(`/api/order/party/${payload.id}/resend-email`, payload)
                .then(res => {
                    resolve(res.data.data.primaryObject)
                })
                .catch(err => {
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    saveParty(payload, id){
        return new Promise((resolve, reject)=>{
            client({requiresAuth: true}).post(`/api/order/party/${id}`, payload)
            .then(res => {
              resolve(res.data.data.primaryObject)
              //resolve(res.data.data)
                  
                })
                .catch(err => {
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    setDirectDeliveryParty(id, payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/party/'+id+'/direct-delivery', payload )
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    togglePartyHold(id){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/party/'+id+'/toggleHold', null )
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    setDirectDeliveryCustomer(id, payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/custlist/'+id+'/direct-delivery', payload )
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    deleteCustlist(id, payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/custlist/'+id+'/delete', payload )
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    loadParty(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/order/party/'+payload )
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    addParticipant(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/party/'+payload.partyId+'/add', {personId:payload.personId})
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    addFocusProduct(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/party/'+payload.partyId+'/add-focus-product', {sku:payload.sku, price:payload.price})
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    removeFocusProduct(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/party/'+payload.partyId+'/remove-focus-product', {sku:payload.sku})
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    moveParticipant(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/party/'+payload.partyId+'/add', {custListId:payload.custListId})
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    addProductToWoc(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/custlist/'+payload.personId+'/increase', {sku:payload.sku, linetype:payload.line_type})
            .then((res)=>{
                resolve(res.data.data.primaryObject)
            })
            .catch((err)=>{
                console.log("Service:parties - Error:",err)
                reject(err)
            })
        });
    },
    removeProductFromWoc(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/custlist/'+payload.personId+'/decrease', {sku:payload.sku, linetype:payload.line_type})
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    reserveLine(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/custlist/'+payload.custId+'/line/'+payload.lineId+'/reserve')
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    releaseReservedLine(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/custlist/'+payload.custId+'/line/'+payload.lineId+'/release-reservation')
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    backorderLine(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/custlist/'+payload.custId+'/line/'+payload.lineId+'/backorder')
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    cancelBackorderedLine(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/custlist/'+payload.custId+'/line/'+payload.lineId+'/cancel-backorder')
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    returnLine(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/custlist/'+payload.custId+'/line/'+payload.lineId+'/return')
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    cancelReturnedLine(payload){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).post('/api/order/custlist/'+payload.custId+'/line/'+payload.lineId+'/cancelReturn')
                .then((res)=>{
                    resolve(res.data.data.primaryObject)
                })
                .catch((err)=>{
                    console.log("Service:parties - Error:",err)
                    reject(err)
                })
        });
    },
    getCalendar(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/calendar')
            .then((res)=>{
              resolve(res.data.data.primaryObject)
            })
            .catch((err)=>{
              console.log("Service:parties - Error:",err)
              reject(err)
            })
        });
    },
  getCalendarRange(payload){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true}).get('/api/calendar/range/from/'+payload.from+'/to/'+payload.to )
        .then((res)=>{
           resolve(res.data.data.primaryObject)
        })
        .catch((err)=>{
          console.log("Service:parties - Error:",err)
          reject(err)
        })
    });
    
  }
}
